export const LEVELS = [
  {
    id: 'FeedTheBirds',
    loader: 'fauna',
    win_copy: { title: 'FeedTheBirds_win_title', copy: 'FeedTheBirds_win_copy' },
    fail_copy: { title: 'FeedTheBirds_fail_title', hint: 'FeedTheBirds_fail_hint' },
  },
  {
    id: 'KeepOutTheCold',
    loader: 'energy',
    win_copy: { title: 'KeepOutTheCold_win_title', copy: 'KeepOutTheCold_win_copy' },
    fail_copy: { title: 'KeepOutTheCold_fail_title', hint: 'KeepOutTheCold_fail_hint' },
  },
  {
    id: 'BeeKind',
    loader: 'fauna',
    win_copy: { title: 'BeeKind_win_title', copy: 'BeeKind_win_copy' },
    fail_copy: { title: 'BeeKind_fail_title', hint: 'BeeKind_fail_hint' },
  },
  {
    id: 'EndlessSoapBar',
    loader: 'recycling',
    win_copy: { title: 'EndlessSoapBar_win_title', copy: 'EndlessSoapBar_win_copy' },
    fail_copy: { title: 'EndlessSoapBar_fail_title', hint: 'EndlessSoapBar_fail_hint' },
  },
  {
    id: 'FriendlyFlora',
    loader: 'flora',
    win_copy: { title: 'FriendFlora_win_title', copy: 'FriendFlora_win_copy' },
    fail_copy: { title: 'FriendFlora_fail_title', hint: 'FriendFlora_fail_hint' },
  },
  {
    id: 'WaterSaviour',
    loader: 'water',
    win_copy: { title: 'WaterSaviour_win_title', copy: 'WaterSaviour_win_copy' },
    fail_copy: { title: 'WaterSaviour_fail_title', hint: 'WaterSaviour_fail_hint' },
  },
  {
    id: 'EnergySaver',
    loader: 'energy',
    win_copy: { title: 'EnergySaver_win_title', copy: 'EnergySaver_win_copy' },
    fail_copy: { title: 'EnergySaver_fail_title', hint: 'EnergySaver_fail_hint' },
  },
  {
    id: 'EcoExpert',
    loader: 'recycling',
    win_copy: { title: 'EcoExpert_win_title', copy: 'EcoExpert_win_copy' },
    fail_copy: { title: 'EcoExpert_fail_title', hint: 'EcoExpert_fail_hint' },
  },
];

export const ONBOARDING_INITIAL_DELAY = 10000; // ms
